import React, { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import Icon from '@components/atoms/icon/icon';
import { OrderSaleTab } from '../type';
import styles from '../products.module.scss';

const NoItemView: React.FC<{
  currentTab: OrderSaleTab;
  forTab: OrderSaleTab;
}> = ({ currentTab, forTab }) => {
  const { t } = useTranslation('orders-sales');
  const innerView = (
    icon: string,
    title: string,
    desc: string,
    button: string,
    link: string,
    buttonIcon?: ReactElement,
  ): ReactElement => {
    const negLeft = currentTab !== forTab ? 'ordersSales__mainLeft__noItems--neg' : '';
    return (
      <div className={clsx(styles.ordersSales__mainLeft__noItems, styles[negLeft])}>
        <Icon
          className={styles.ordersSales__mainLeft__noItems__icon}
          name={icon}
          ariaHidden
        />
        <div className={styles.ordersSales__mainLeft__noItems__title}>{title}</div>
        <div className={styles.ordersSales__mainLeft__noItems__desc}>{desc}</div>
        <a
          href={link}
          className={clsx('vc-btn vc-btn--medium vc-btn--primary', styles.ordersSales__mainLeft__noItems__btn)}
        >
          {buttonIcon}
          {button}
        </a>
      </div>
    );
  };

  if (forTab === 'Order') {
    return innerView(
      'cart-16',
      t('MY_ACCOUNT.ORDERS_SALES.LIST.NO_ORDERS_YET'),
      t('MY_ACCOUNT.ORDERS_SALES.LIST.NO_ORDERS_YET_DESC'),
      t('MY_ACCOUNT.ORDERS_SALES.LIST.NO_ORDERS_YET_BUTTON'),
      '/',
    );
  } else {
    return innerView(
      'box',
      t('MY_ACCOUNT.ORDERS_SALES.LIST.NO_SALES_YET'),
      t('MY_ACCOUNT.ORDERS_SALES.LIST.NO_SALES_YET_DESC'),
      t('MY_ACCOUNT.ORDERS_SALES.LIST.NO_SALES_YET_BUTTON'),
      '/sell-clothes-online',
      <div className={styles.ordersSales__mainLeft__noItems__btn__icon}>
        <Icon
          name="cross-plus-thick"
          className={styles.ordersSales__mainLeft__noItems__btn__icon__svg}
          ariaHidden
        />
      </div>,
    );
  }
};

export default NoItemView;
